[
  {
    "code": "PE-AMA",
    "name": "Amazonas"
  },
  {
    "code": "PE-ANC",
    "name": "Ancash"
  },
  {
    "code": "PE-APU",
    "name": "Apurímac"
  },
  {
    "code": "PE-ARE",
    "name": "Arequipa"
  },
  {
    "code": "PE-AYA",
    "name": "Ayacucho"
  },
  {
    "code": "PE-CAJ",
    "name": "Cajamarca"
  },
  {
    "code": "PE-CUS",
    "name": "Cuzco [Cusco]"
  },
  {
    "code": "PE-CAL",
    "name": "El Callao"
  },
  {
    "code": "PE-HUV",
    "name": "Huancavelica"
  },
  {
    "code": "PE-HUC",
    "name": "Huánuco"
  },
  {
    "code": "PE-ICA",
    "name": "Ica"
  },
  {
    "code": "PE-JUN",
    "name": "Junín"
  },
  {
    "code": "PE-LAL",
    "name": "La Libertad"
  },
  {
    "code": "PE-LAM",
    "name": "Lambayeque"
  },
  {
    "code": "PE-LIM",
    "name": "Lima"
  },
  {
    "code": "PE-LOR",
    "name": "Loreto"
  },
  {
    "code": "PE-MDD",
    "name": "Madre de Dios"
  },
  {
    "code": "PE-MOQ",
    "name": "Moquegua"
  },
  {
    "code": "PE-PAS",
    "name": "Pasco"
  },
  {
    "code": "PE-PIU",
    "name": "Piura"
  },
  {
    "code": "PE-PUN",
    "name": "Puno"
  },
  {
    "code": "PE-SAM",
    "name": "San Martín"
  },
  {
    "code": "PE-TAC",
    "name": "Tacna"
  },
  {
    "code": "PE-TUM",
    "name": "Tumbes"
  },
  {
    "code": "PE-UCA",
    "name": "Ucayali"
  }
]